import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Checkbox } from "../../../../../ui/Checkbox/Checkbox";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { useApprovedBrand } from "./useApprovedBrand";
import { useApprovedBrandOptions } from "./useApprovedBrandOptions";

const id = "dealer-tire-approved-brand-panel";

export const TireApprovedBrandFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, true);
  const { t } = useTranslation();
  const options = useApprovedBrandOptions();
  const [, { toggle }] = useApprovedBrand();
  if (!options.length) {
    return null;
  }
  return (
    <Collapsible
      className="space-y-2"
      id={id}
      label={t("searchResults.approvedBrandCategory")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ checked, label, value }) => (
        <label className="flex gap-x-4" key={value}>
          <Checkbox
            onChange={(): void => {
              toggle([value]);
            }}
            checked={checked}
            checkedClassName="text-selected-tab"
            name="approvedBrand"
          />
          <span className="flex-1">{label}</span>
        </label>
      ))}
    </Collapsible>
  );
};
